/**
 * Safely attempt to play a video element.
 * Catches and ignores autoplay restrictions (common on iOS/mobile).
 *
 * Also guards against iOS Safari / WKWebView forcing native fullscreen
 * inside iframes (miniapp context) by intercepting the
 * `webkitbeginfullscreen` event and switching back to inline presentation.
 */
const safeTryPlayVideo = (video: HTMLVideoElement): void => {
  video.play().catch(() => {
    // Autoplay may be blocked - expected on iOS and mobile browsers
  });
};

export default safeTryPlayVideo;
